// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2P-KF","title":"Info_title__3VrP_","links":"Info_links__11NXk","link":"Info_link__4rDoj","logo":"Info_logo__1MeiE"};